import React from 'react'
import { Card, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList, optionsRevenue } from '../../../../Data/DashboardsData/ECommerceData'
import { RecentStatisticsTitle } from '../../../../Utils/Constants'
import ReactApexChart from 'react-apexcharts'

export default function RecentStatistics() {
    return (
        <Col xl={4} sm={6}>
            <Card>
                <DropdownWithHeader headerClass='pb-0' heading={RecentStatisticsTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <div className="card-body p-0">
                    <div id="revenueChart">
                        <ReactApexChart type='line' options={optionsRevenue} series={optionsRevenue.series} height={358} />
                    </div>
                </div>
            </Card>
        </Col>
    )
}